// API Status Codes
export const API_SUCCESS_STATUS_CODE = 0;
export const API_FAILURE_STATUS_CODE = 1;
export const PAYMENT_FALLBACK_STATUS_CODE = 5;
export const ORDER_INTERRUPTION_STATUS_CODE = 9;
export const IM_DUPLICATE_ORDER_STATUS_CODE = 360;
export const IM_DUPLICATE_PAYMENT_STATUS_CODE = 362;
export const CONFIRM_ORDER_RETRY_STATUS_CODE = 23;
export const BAD_DEBIT_CODE = 8;
export const INVALID_COUPON_STATUS_CODE = 4;
export const CARD_RATE_LIMIT_EXCEEDED_STATUS_CODE = 15;
export const ORDER_TERMINAL_STATUS_CODE = 11;
export const DINEOUT_BILL_PAYMENT_INVALID_QR_STATUS_CODE = 191;
export const DINEOUT_MAX_ITEM_BREACH_STATUS_CODE = 107; // This is used to handle cart item qty which is exceeding inventory
export const DINEOUT_INCORRECT_DINECASH_POOLED_AMOUNT_STATUS_CODE = 121;

// Autopay POD related Status Codes
export const PAYMENT_MAX_RETRIES_EXCEEDED_STATUS_CODE = 120;
export const PAST_PAYMENT_PENDING_STATUS_CODE = 13;
export const PAST_PAYMENT_ALREADY_SUCCESSFUL_STATUS_CODE = 12;
export const PAYMENT_MAX_RETRIES_EXCEEDED_SOFT_FAILURE_STATUS_CODE = 14;

// Autopay POD Cart Key Failures
export const POD_ORDER_CANCELLED = 33;
export const POD_ORDER_ALREADY_PAID = 70;
